<template>
  <div :style="styles" class="t-bar">

    <div class="align-start">
      <slot name="start"/>
    </div>

    <div class="align-middle">
      <slot name="middle" />
    </div>

    <div class="align-end">
      <slot name="end"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 't-bar'
}
</script>

<style scoped lang="scss">
%section {
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-align: center;
  align-items: center;
  min-width: 0;
  z-index: 1;
  height: 100%;
}

.t-bar {
  @include container-element;
  background-color: var(--header);
  color: var(--on-header);
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .align-start {
    justify-self: flex-start;
    align-self: center;
  }

  .align-middle {
    justify-self: flex-end;
  }

  .align-end {
    justify-self: flex-end;
    align-self: center;
  }

}
</style>
